// src/services/applicationService.js
import axios from "axios";
import apiUrls from "../config/api-urls";

export const fetchUserApplications = async (userId, token) => {
  try {
    const response = await axios.get(`${apiUrls.application.userApplications}/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data.data; 
  } catch (error) {
    throw error;
  }
};
